import { Color } from '@medly-components/theme';

const coral: Color = {
    50: '#FFF1EF',
    100: '#FFD2CE',
    200: '#FFBDB6',
    300: '#FF9F95',
    400: '#FF8C81',
    500: '#FF6F61',
    600: '#E86558',
    700: '#B54F45',
    800: '#8C3D35'
};

export default coral;
